module.exports = __webpack_public_path__ + "static/media/1-2.121b0304.mp3";